var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-section" }, [
    _c(
      "div",
      {
        staticClass:
          "emd-container _highlight_header _header_spaced _footer_spaced_sm",
      },
      [
        _c("div", { staticClass: "emd-container__header" }, [
          _c("h2", { staticClass: "emd-text _size_section" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("recipients.details.list.anticipation.title")) +
                " "
            ),
          ]),
        ]),
      ]
    ),
    _c("div", { staticClass: "emd-card-grid" }, [
      _c(
        "div",
        { staticClass: "el-grid-list el-section _separator" },
        [
          _c("div", { staticClass: "el-bounds" }, [
            _c("div", { staticClass: "demo-grid-item _separator" }, [
              _c("label", { staticClass: "emd-text _type_caption" }, [
                _vm._v(
                  _vm._s(_vm.$t("recipients.details.list.anticipation.enabled"))
                ),
              ]),
              _c(
                "p",
                {
                  staticClass: "emd-card-grid__line emd-text",
                  class: _vm.status,
                  staticStyle: { "font-weight": "bold" },
                },
                [_vm._v(" " + _vm._s(_vm.$t(_vm.automatic)) + " ")]
              ),
            ]),
          ]),
          _vm.data && _vm.data.enabled
            ? [
                _c("div", { staticClass: "el-bounds" }, [
                  _c("div", { staticClass: "demo-grid-item" }, [
                    _c("label", { staticClass: "emd-text _type_caption" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("recipients.details.list.anticipation.type")
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "emd-card-grid__line emd-text" }, [
                      _vm._v(_vm._s(_vm.data.type_label)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "el-bounds" }, [
                  _c("div", { staticClass: "demo-grid-item" }, [
                    _c("label", { staticClass: "emd-text _type_caption" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "recipients.details.list.anticipation.volume_percentage"
                          )
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "emd-card-grid__line emd-text" }, [
                      _vm._v(_vm._s(_vm.percent)),
                    ]),
                  ]),
                ]),
                _vm.data.day_anticipation
                  ? _c("div", { staticClass: "el-bounds" }, [
                      _c("div", { staticClass: "demo-grid-item" }, [
                        _c("label", { staticClass: "emd-text _type_caption" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("recipients.details.list.anticipation.day")
                            )
                          ),
                        ]),
                        _c(
                          "p",
                          { staticClass: "emd-card-grid__line emd-text" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.data.day_anticipation) + " "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "el-bounds" }, [
                  _c("div", { staticClass: "demo-grid-item" }, [
                    _c("label", { staticClass: "emd-text _type_caption" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("recipients.details.list.anticipation.delay")
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "emd-card-grid__line emd-text" }, [
                      _vm._v(_vm._s(_vm.delay)),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }